"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padItemStyle = void 0;
exports.padItemStyle = {
    borderRadius: '.5rem',
    minWidth: '2.5rem',
};
